var map = {
	"./en/": [
		3859,
		859
	],
	"./en/admin": [
		6332,
		951
	],
	"./en/admin.json": [
		6332,
		951
	],
	"./en/common": [
		8062,
		62
	],
	"./en/common.json": [
		8062,
		62
	],
	"./en/index": [
		3859,
		859
	],
	"./en/index.json": [
		3859,
		859
	],
	"./en/playerId": [
		5611,
		611
	],
	"./en/playerId.json": [
		5611,
		611
	],
	"./en/roomId": [
		5769,
		769
	],
	"./en/roomId.json": [
		5769,
		769
	],
	"./es/": [
		8872,
		872
	],
	"./es/admin": [
		2592,
		211
	],
	"./es/admin.json": [
		2592,
		211
	],
	"./es/common": [
		4595,
		595
	],
	"./es/common.json": [
		4595,
		595
	],
	"./es/index": [
		8872,
		872
	],
	"./es/index.json": [
		8872,
		872
	],
	"./es/playerId": [
		5566,
		566
	],
	"./es/playerId.json": [
		5566,
		566
	],
	"./es/roomId": [
		3256,
		256
	],
	"./es/roomId.json": [
		3256,
		256
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5314;
module.exports = webpackAsyncContext;